import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "../locales/en.json";
import fr from "../locales/fr.json";

import { storage } from "./storage";
import { LanguageObject } from "../types/data-types";
import { iso6393, Language } from "iso-639-3";

const resources = { en, fr };
const supportedLanguageCodes = Object.keys(resources);

export const LanguagesSupported: LanguageObject[] = [
  { label: "English", value: "en" },
  { label: "Français", value: "fr" },
];

export function normalizeLanguageCode(lang: string | undefined | null): string {
  const configuredDefault = window._env_?.DEFAULT_LANG?.toLowerCase();
  const defaultLang = configuredDefault && supportedLanguageCodes.includes(configuredDefault)
    ? configuredDefault
    : "fr";
  if (!lang) return defaultLang;

  const code = lang.toLowerCase();
  let normalized: string | undefined;

  if (code.length === 2) {
    const match = iso6393.find((entry) => entry.iso6391 === code);
    normalized = match?.iso6391;
  }

  if (code.length === 3) {
    const match = iso6393.find((entry) => entry.iso6393 === code);
    normalized = match?.iso6391;
  }

  return normalized && supportedLanguageCodes.includes(normalized) ? normalized : defaultLang;
}

export function getLanguageCodes(lang: string): string[] {
  const normalized = normalizeLanguageCode(lang);
  const entry = iso6393.find((e: Language) => e.iso6391 === normalized);

  if (!entry) return [normalized];

  const aliases = new Set<string>();

  if (entry.iso6391) aliases.add(entry.iso6391);
  aliases.add(entry.iso6393);

  return Array.from(aliases);
}

export const defaultLanguage = normalizeLanguageCode(window._env_?.DEFAULT_LANG);
export const selected_language = normalizeLanguageCode(storage.getItem(storage.SELECTED_LANGUAGE));

i18n.use(initReactI18next).init({
  resources,
  lng: selected_language || defaultLanguage,
  fallbackLng: defaultLanguage,
  interpolation: {
    escapeValue: false,
  },
});

export const switchLanguage = async (language: string) => {
  const normalized = normalizeLanguageCode(language);
  storage.setItem(storage.SELECTED_LANGUAGE, normalized);
  await i18n.changeLanguage(normalized);
};

export const isRTL = (language: string) => {
  return normalizeLanguageCode(language) === "ar";
};

export const getDirCurrentLanguage = (language: string) => {
  return isRTL(language) ? "rtl" : "ltr";
};
